import { loadEnvConfig } from "../../environments/base";
import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";

import "./StripePricingTable.css";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";

const pricingTableId = loadEnvConfig("REACT_APP_STRIPE_PRICING_TABLE_ID");
const publishableKey = loadEnvConfig("REACT_APP_STRIPE_PUBLISHABLE_KEY");

const StripePricingTable: React.FC = () => {
  const storeUser = useSelector(selectUser);

  useEffect(() => {
    // Ensure the Stripe script is loaded
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="stripe-pricing-screen">
      <stripe-pricing-table
        pricing-table-id={pricingTableId}
        publishable-key={publishableKey}
        client-reference-id={storeUser?.id || ""}
        success-url={`https://staging.usewinslow.com/stripe-success?userId=${storeUser?.id || ""}`}
        cancel-url="https://staging.usewinslow.com/stripe-cancel"></stripe-pricing-table>
    </div>
  );
};

export default StripePricingTable;
